import {Button, Card, Form, Input, Modal} from 'antd';
import {jwtDecode} from 'jwt-decode';
import PropTypes from 'prop-types';
import {useState} from 'react';
import {toast} from 'react-hot-toast';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {RQUserLoginAPI} from '../../reactQuery/apis';
import {loginSuccess} from '../../redux/authAction';

import {ForgotPasswordScreen} from './ForgetPasswordScreen';
import {RegistrationScreen} from './RegistrationScreen';

const LoginScreen = ({onClose}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showRegister, setShowRegister] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const {mutate: loginUser, isLoading} = RQUserLoginAPI({
    onSuccess: res => {
      if (res?.token) {
        const decoded = jwtDecode(res.token);
        dispatch(loginSuccess({...res, role: decoded.role}));
        toast.success('Login successful'); // friendly success message
        onClose(); // close the login modal

        if (decoded.role === 'ADMIN') {
          navigate('/admin/dashboard');
        }
      }
    },
    onError: err => {
      if (err?.response?.status === 401) {
        toast.error('Invalid email or password');
      } else if (!err?.response) {

        toast.error('Network error, please check your connection');
      } else {
      // Any other error
        toast.error('Something went wrong, please try again');
      }
    },
  });

  const openLoginModal = () => {
    setShowRegister(false);
    setShowForgotPassword(false);
  };

  return (
    <Modal
      centered
      open
      footer={null}
      maskClosable={false}
      onCancel={onClose}
      width={600}
      maskClassName={'login-blur-mask'}
    >
      {showRegister ? (
        <RegistrationScreen
          setShowRegister={setShowRegister}
          openLoginModal={openLoginModal} // Switch back to login modal
        />
      ) : showForgotPassword ? (
        <ForgotPasswordScreen
          setShowForgotPassword={setShowForgotPassword}
          openLoginModal={openLoginModal} // Switch back to login modal
        />
      ) : (
        <Card bordered={false}>
          <Form layout={'vertical'} onFinish={loginUser}>
            <h2 className={'md:text-3xl text-xl md:mb-8 mb-5 text-primary-900 flex font-semibold w-full justify-center items-center font-instrument '}>
              Sign in to continue
            </h2>

            <Form.Item
              label={'Email'}
              name={'email'}
              rules={[{required: true, message: 'Email is required'},  {type: 'email'} ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={'Password'}
              name={'password'}
              rules={[{required: true, message: 'Password is required'}]}
            >
              <Input.Password />
            </Form.Item>

            <div className={'text-right mb-4'}>
              <Button
                type={'link'}
                onClick={() => setShowForgotPassword(true)}
              >
                Forgot Password?
              </Button>
            </div>

            <Button
              htmlType={'submit'}
              loading={isLoading}
              className={'w-full !bg-primary-800 !text-white'}
            >
              Login
            </Button>

            <Button
              type={'link'}
              className={'w-full mt-4'}
              onClick={() => setShowRegister(true)}
            >
              Don’t have an account? Register
            </Button>
          </Form>
        </Card>
      )}
    </Modal>
  );
};

LoginScreen.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default LoginScreen;
